module.exports = __webpack_public_path__ + "static/media/22_r_stena_84.22_0.f888cbc6.png";